<template>
  <div class="home">
    <div class="header-banner">
      <!-- <BannerSlider :vName="vName" :hasV="hasV" /> -->
      <!-- <ProductFeature /> -->
      <ProductFeatureList />

      <FooterBar />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";

import { LocationId } from "../../services/storage.service";
import BannerSlider from "../Home/BannerSlider/BannerSlider.vue";
// import ProductFeature from "../Home/ProductFeature/ProductFeatureView.vue";
import ProductFeatureList from "../Home/ProductFeature/ProductFeatureList.vue";

import Header from "@/components/Header/Header.vue";
import FooterBar from "@/components/FloatingFooter/FooterBar.vue";
import router from "../../router";

export default {
  name: "View",
  components: {
    BannerSlider,
    ProductFeatureList,
    Header,
    FooterBar,
  },
  data() {
    return {
      sliderData: BannerCara,
      hasV: 0,
      vName: "",
      slugs: {},
    };
  },
  created() {
    this.checkLocationIdInUrl();
    this.megamenu(LocationId.getLocationId());

    let that = this;
    if (LocationId.getLocationId() === null) {
      this.$confirm({
        title: "Where are you ordering from?",
        okText: "Pokhara",
        okType: "primary",
        cancelText: "Kathmandu",
        onOk() {
          that.updateLocationId(2);
          that.clearCart();
          // router.push("/pkr/c/:slug?");
        },
        onCancel() {
          that.updateLocationId(1);
          that.clearCart();
          // router.push("/ktm/c/:slug?");
        },
      });
    }

    // this.checkParams();
    window.scrollTo(0, 0);






    // document.title = nearestWithTitle.meta.title;
    
    
    document.title = this.$route.params.slug +" | "+ this.$route.meta.title;

  },
  methods: {
    ...mapActions(["updateLocationId", "clearCart", "megamenu"]),

    checkParams: function () {
      // console.log("::" + this.$route.params.slug);
      this.vName = this.$route.params.slug;

      if (this.$route.params.slug != undefined) {
        this.hasV = 1;
        //if Number
        if (!isNaN(this.vName)) {
          // console.log("Number : " + Number(this.vName));
        }
        // endif NaN
        //if String
        else {
          // console.log("String : " + this.vName)
        }
        // end isnan string
      } else {
        this.hasV = 0;
        // router.push("/");
        if (LocationId.getLocationId() == 1) {
          router.push("/ktm");
        } else if (LocationId.getLocationId() == 2) {
          router.push("/pkr");
        }
      }
    },

    checkLocationIdInUrl: function () {
      if (this.$route.params.loc == "ktm") {
        this.updateLocationId(1);
      } else if (this.$route.params.loc == "pkr") {
        this.updateLocationId(2);
      }
    },
  },
  watch: {
    $route(from, to) {
      // console.log(from);
      // console.log(to);
      this.checkParams();
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
.ant-modal-confirm-body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  .ant-modal-confirm-title {
    text-align: center;
    margin-top: 20px;
  }
}
.ant-modal-confirm {
  .ant-modal-confirm-btns {
    float: none;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
